/* eslint-disable import/no-anonymous-default-export */
import RecipeConstants from './RecipeConsts'

const initialState = {
    status: '',
    ingredients: [],
    ingredientsInventory: [],
    analyzedIngredients: [],
    analyzeStatus: false,
    recipes: undefined,
    selectedRecipe: undefined,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case RecipeConstants.INGREDIENTS_INVENTORY_SUCCESS: {
            console.log('ingredients', action.payload.data);
            return {
                ...state,
                status: 'success',
                ingredientsInventory: action.payload.data,
            };
        }
        case RecipeConstants.INGREDIENTS_INVENTORY_FAILURE: {
            return {
                ...state,
                status: 'failure',
                ingredientsInventory: [],
            };
        }
        case RecipeConstants.SELECTED_INGREDIENTS_UPDATE: {
            console.log('ingredients', action.payload);
            return {
                ...state,
                status: 'success',
                ingredients: action.payload,
            };
        }
        case RecipeConstants.SELECTED_INGREDIENTS_CLEAR: {
            return {
                ...state,
                status: 'success',
                ingredients: [],
                recipes: undefined,
                selectedRecipe: undefined
            };
        }
        case RecipeConstants.ANALYZE_INGREDIENTS_SUCCESS: {
            const ingredients = action.payload.data;
            const selectedAnlyze = { ingredients: ingredients?.map((ingredient) => ({ id: ingredient.id, name: ingredient.name })) };
            return {
                ...state,
                status: 'success',
                ingredients: selectedAnlyze,
                analyzedIngredients: ingredients?.map((ingredient) => ingredient.name),
                analyzeStatus: true
            };
        }
        case RecipeConstants.ANALYZE_INGREDIENTS_FAILURE: {
            return {
                ...state,
                status: 'failure',
                analyzedIngredients: action.payload.data,
                analyzeStatus: false
            };
        }

        case RecipeConstants.CLEAR_ANALYZE_STATUS: {
            return {
                ...state,
                status: 'success',
                analyzeStatus: false
            };
        }

        case RecipeConstants.RECIPES_SUGGESTIONS_SUCCESS: {
            return {
                ...state,
                status: 'success',
                recipes: action.payload.data,
            };
        }

        case RecipeConstants.RECIPES_SUGGESTIONS_UPDATE: {
            return {
                ...state,
                status: 'success',
                recipes: action.payload.recipes,
            };
        }
        case RecipeConstants.RECIPES_SUGGESTIONS_FAILURE: {
            return {
                ...state,
                status: 'failure',
                recipes: undefined,
            };
        }
        case RecipeConstants.SUGGESTED_RECIPE_CLEAR: {
            return {
                ...state,
                status: 'success',
                recipes: undefined,
            };
        }
        case RecipeConstants.RECIPE_SELECT_UPDATE: {

            const updatedSelectedRecipe = action.payload.recipe;
            const matchingRecipe = state.recipes.find((recipe) => recipe.id === updatedSelectedRecipe.id);
            return {
                ...state,
                status: 'success',
                selectedRecipe: matchingRecipe,
            };
        }
        case RecipeConstants.RECIPE_GENERATE_SUCCESS: {
            return {
                ...state,
                status: 'success',
                selectedRecipe: action.payload.data,
            };
        }
        default:
            return state
    }
}